import React, { Component } from 'react';
import I18n from 'lib/i18n/i18n';
import {imageUrl} from "../../helpers/ApplicationHelper";

class PricingContent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {section} = this.props
        return (
            <div className={'content-item'}>
                <img src={imageUrl(`item/trends/${section}.svg`)} />
                <div className={'text'}>
                    <div className={'description'}>{I18n.getString(`itemPage::trends::listingTrends::pricing::content::${section}Description`)}</div>
                </div>
            </div>
        )
    }
}

export default PricingContent